import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const LostAndFound = () => {
  return (
    <div style={{ position: 'relative', width: '100%', minHeight: '80vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
      <Helmet>
        <title>Lost & Found Portal | krul nazg durbatulûk</title>
        <meta name="description" content="If you have found an item belonging to Ariel Rotem with the inscription krul nazg durbatulûk or similar engravings, please use this portal to contact me." />
        <meta name="robots" content="index, follow" />
        <link rel="icon" type="image/png" href="/mordor_favicon.png" />
        <link rel="apple-touch-icon" href="/mordor_favicon.png" />
      </Helmet>

      <div className="sauron-tower" style={{
        position: 'absolute',
        bottom: '0',
        right: '-10%',
        width: '60vw',
        height: '80vh',
        backgroundImage: 'url(/sauron_tower.png)',
        backgroundSize: 'contain',
        backgroundPosition: 'bottom right',
        backgroundRepeat: 'no-repeat',
        opacity: '0.2',
        pointerEvents: 'none',
        zIndex: '0'
      }} />

      <div className="mb-4" style={{ position: 'relative', zIndex: 1 }}>
        <h1 className="glitch" style={{ color: 'var(--accent-secondary)', fontSize: '3rem', textShadow: '0 0 20px var(--accent-primary)' }}>
          $ cat /vault/lost_and_found.log
        </h1>
      </div>

      <div className="terminal-card" style={{ maxWidth: '800px', width: '100%', margin: '0 auto', border: '1px solid var(--accent-primary)', boxShadow: 'var(--glow-shadow)', position: 'relative', zIndex: 1 }}>
        <h2 className="mb-4" style={{ color: 'var(--text-primary)', borderBottom: '1px dashed var(--accent-tertiary)', paddingBottom: '10px' }}>
          &gt; SYSTEM_MESSAGE :: ITEM_RECOVERY
        </h2>
        
        <p className="mono text-primary mb-4" style={{ fontSize: '1.1rem' }}>
          You have reached the official lost and found portal for Ariel Rotem.
        </p>
        
        <p className="mono text-secondary mb-4" style={{ fontSize: '0.95rem' }}>
          I inscribe certain personal items with unique phrases. If you are reading this, it means you have found one of those items, searched the inscription online, and the internet routed you here. Thank you for taking the time to search.
        </p>

        <div style={{ background: 'rgba(0,0,0,0.5)', padding: '30px', borderRadius: '8px', border: '1px solid var(--accent-tertiary)', marginTop: '30px', marginBottom: '30px', position: 'relative', zIndex: 1 }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: '15px' }}>&gt; QUERY_MATCH :: Isildur's_Bane</h3>
          <p className="mono text-secondary mb-4" style={{ fontSize: '0.9rem' }}>
            [ MATCH_FOUND ]: Gold ring of power bearing the following...
          </p>
          
          <div style={{ 
            fontFamily: "'Tangerine', cursive", 
            fontSize: '4rem', 
            color: '#ffcc00', 
            textShadow: '0 0 10px #ff3300, 0 0 20px #ff0000',
            letterSpacing: '5px',
            margin: '20px 0',
            lineHeight: '1.2'
          }}>
            krul nazg durbatulûk
          </div>
          
          <p className="mono" style={{ color: 'var(--accent-secondary)', fontSize: '0.95rem', marginTop: '10px' }}>
            "But they were all of them deceived, for another ring was made."
          </p>
          <p className="mono text-secondary mt-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
            Keep it secret. Keep it safe. And please, return it to its master.
          </p>
        </div>

        <div className="mt-4 pt-4" style={{ borderTop: '1px dashed var(--accent-tertiary)' }}>
          <p className="mono text-primary mb-4" style={{ fontSize: '1.1rem' }}>
            If you have found this item, please reach out to me so it can be returned.
          </p>
          <Link to="/contact" className="btn" style={{ fontSize: '1.2rem', padding: '15px 30px', display: 'inline-block' }}>
            &gt; INITIATE_CONTACT
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LostAndFound;
